import openedAccordion from "../../assets/images/accordion-opened.svg";
import closedAccordion from "../../assets/images/accordion-closed.svg";
import React from "react";

function ToggleAccordion({ open, onClick }) {
    return <img src={open ? openedAccordion : closedAccordion} className="accordion-icon" onClick={onClick} />;
}

export default ToggleAccordion;
